import apiServiceHandler from "./APIServiceHandler";
export const BASE_BULLETIN_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// API URLs
const GetBulletinsURL = `${BASE_BULLETIN_URL}/bulletins`;
const CreateBulletinURL = `${BASE_BULLETIN_URL}/bulletins`;
const UpdateBulletinURL = `${BASE_BULLETIN_URL}/bulletins`;
const DeleteBulletinURL = `${BASE_BULLETIN_URL}/bulletins`;

// Interfaces
export interface BulletinItem {
    _id: string;
    title: string;
    content: string;
    createdAt: string;
    createdBy?: string;
}

export interface CreateBulletinPayload {
    title: string;
    content: string;
    createdBy?: string;
}

export interface UpdateBulletinPayload {
    title?: string;
    content?: string;
}

// API Functions
export const GetBulletins = async (): Promise<BulletinItem[]> => {
    try {
        const response = await apiServiceHandler.get<BulletinItem[] | null>(GetBulletinsURL);
        if (response === null) throw new Error('No data returned');
        // Map _id to id for frontend compatibility if needed
        // return response.map(item => ({ ...item, id: item._id }));
        return response;
    } catch (error) {
        console.error('GetBulletins error:', error);
        throw error;
    }
};

export const CreateBulletin = async (payload: CreateBulletinPayload): Promise<BulletinItem> => {
    try {
        const response = await apiServiceHandler.post<BulletinItem | null>(CreateBulletinURL, payload);
        if (response === null) throw new Error('No data returned');
        return response;
    } catch (error) {
        console.error('CreateBulletin error:', error);
        throw error;
    }
};

export const UpdateBulletin = async (id: string, payload: UpdateBulletinPayload): Promise<BulletinItem> => {
    try {
        // Only send title and content, as expected by backend
        const url = `${UpdateBulletinURL}/${id}`;
        const { title, content } = payload;
        const response = await apiServiceHandler.put<BulletinItem | null>(url, { title, content });
        if (response === null) throw new Error('No data returned');
        return response;
    } catch (error) {
        console.error('UpdateBulletin error:', error);
        throw error;
    }
};

export const DeleteBulletin = async (id: string): Promise<{ message: string }> => {
    try {
        const url = `${DeleteBulletinURL}/${id}`;
        const response = await apiServiceHandler.delete<{ message: string } | null>(url);
        if (response === null) throw new Error('No data returned');
        return response;
    } catch (error) {
        console.error('DeleteBulletin error:', error);
        throw error;
    }
};
